import { VsfContext } from '~/composables/context';
import { Logger } from '~/helpers/logger';
import { productPdfUrl } from "~/modules/pdfDownload/graphql/productUrl.gql";


export const productUrlConfig = {
  execute: async (context: VsfContext, sku) => {
    const { data } = await context.$magento.api.customMutation({ mutation: productPdfUrl, mutationVariables: {sku: sku} });
    Logger.debug('[Result]:', { data });

    console.log(data);
    return  data
  },
};

